import './index_web.css';
import useTheme from '../../../utilities/hooks/theme';
import { View, Text } from '../../../component';
import React from 'react';
import { CounterWrapper } from '../../../component/header_with_timer';
import { isMatchInScheduled } from '../../../utilities/helper';
import { useLink, useRouteLocation } from 'react-router-stack';
import Constants from '../../../constants';

type TeamPreviewHeaderProps = {
  username: string;
  teamNumber: number;
  completed: boolean;
  userTeamScore: number;
  teamA: any;
  teamB: any;
};

const TeamPreviewHeader = ({
  username,
  teamNumber = 1,
  completed = false,
  userTeamScore,
  teamA = {},
  teamB = {}
}: TeamPreviewHeaderProps) => {
  const { FantasyTheme: theme } = useTheme();
  const teamNumberColor = {
    color: '#fff'
  };

  const scoreColor = {
    color: theme.teamPreviewScore
  };
  const navigate = useLink();
  const { state = {} } = useRouteLocation();

  const userName = username.match(/^[0-9a-fA-F]{24}$/) ? '' : `${username}`;
  const onCalledDeadline = () => {
    navigate.push('/', { replace: true });
  };
  const {
    item: matchItem = {},

    gameType = ''
  } = state;
  const { status: matchStatus, verified, gameState = 0, matchDelayed = false } = matchItem;

  const isMatchScheduled = isMatchInScheduled({
    matchStatus,
    gameState,
    matchDelayed,
    gameType
  });
  return (
    <View className="team-preview-header-container">
      <Text className="team-preview-team-number" style={teamNumberColor}>
        {userName ? ` ${username} (T${teamNumber})` : `Team No. ${teamNumber}`}
      </Text>
      {completed && (
        <Text
          className="team-preview-score"
          style={scoreColor}>{`Total Points : ${userTeamScore}`}</Text>
      )}
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <View className="team-preview-team-a-container">
          <Text
            className="team-preview-team-title"
            style={teamNumberColor}>{`${teamA?.shortName}`}</Text>
        </View>

        <View>
          <Text
            className="team-preview-team-title"
            style={{ paddingLeft: '5px', paddingRight: '5px' }}>
            vs
          </Text>
        </View>
        <View className="team-preview-team-b-container">
          <Text
            className="team-preview-team-title"
            style={teamNumberColor}>{`${teamB?.shortName}`}</Text>
        </View>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {isMatchScheduled && (
          <View>
            <View className="header-with-timer-icon-wrapper">
              <Constants.Svgs.Timer width={'20px'} height={'20px'} />
            </View>
          </View>
        )}
        <View>
          {
            <CounterWrapper
              onCalledDeadline={onCalledDeadline}
              matchStatus={matchStatus}
              verified={verified}
              matchItem={matchItem}
              isMatchScheduled={isMatchScheduled}
              gameType={gameType}
            />
          }
        </View>
      </div>
    </View>
  );
};
export default React.memo(TeamPreviewHeader);
